export default __webpack_public_path__ + "static/media/serverimage.177869b7.png";